import React from 'react';
import './Carousel.css';

const slide = {
  title: 'Innovative Web Solutions',
  description:
    'We provide tailored solutions for your business, ensuring high performance and scalability.',
};

const Carousel = () => {
  return (
    <section className="snow-hero" id="hero">
      {/* Animated background elements */}
      <div className="snow-hero-bg">
        <div className="snow-hero-orb snow-hero-orb-1"></div>
        <div className="snow-hero-orb snow-hero-orb-2"></div>
        <div className="snow-hero-orb snow-hero-orb-3"></div>
        <div className="snow-hero-mountain-layer"></div>
      </div>

      <div className="snow-hero-content">
        <div className="snow-hero-badge">
          <span className="snow-hero-badge-dot"></span>
          Your Trusted Technology Partner
        </div>

        <h1 style={{"color": "white"}} className="snow-hero-title">
          {slide.title}
        </h1>

        <p className="snow-hero-description">
          {slide.description}
        </p>

        <div className="snow-hero-buttons">
          <a href="#contact" className="snow-btn-primary">
            <span>Get Started</span>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M3 8H13M13 8L8 3M13 8L8 13" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </a>
          <a href="#services" className="snow-btn-secondary">
            Explore Services
          </a>
        </div>
      </div>

      {/* Decorative frost particles */}
      <div className="snow-hero-frost-particles">
        {Array.from({ length: 4 }, (_, i) => (
          <div key={i} className="snow-frost-particle" style={{
            '--x': `${10 + Math.random() * 80}%`,
            '--y': `${10 + Math.random() * 80}%`,
            '--size': `${2 + Math.random() * 4}px`,
            '--delay': `${Math.random() * 5}s`,
            '--duration': `${3 + Math.random() * 4}s`,
          }} />
        ))}
      </div>
    </section>
  );
};

export default Carousel;
